import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("DeprecatedApplicationStore");
export const useDeprecatedApplicationStoreActions = useActions;
export const useDeprecatedApplicationStoreGetters = useGetters;
export const useDeprecatedApplicationStoreMutations = useMutations;
export const useDeprecatedApplicationStoreState = useState;